// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Rq0C","largestCol":"styles_largestCol__3tqu0","smallestCol":"styles_smallestCol__2OUUw"};